"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function TrashIcon(_a) {
    var _b = _a.height, height = _b === void 0 ? "20px" : _b, _c = _a.color, color = _c === void 0 ? "currentColor" : _c, style = _a.style;
    return (react_1.default.createElement("svg", { height: height, viewBox: "0 0 515.556 515.556", fill: color, style: style },
        react_1.default.createElement("path", { d: "m64.444 451.111c0 35.526 28.902 64.444 64.444 64.444h257.778c35.542 0 64.444-28.918 64.444-64.444v-322.222h-386.666z" }),
        react_1.default.createElement("path", { d: "m322.222 32.222v-32.222h-128.889v32.222h-161.111v64.444h451.111v-64.444z" })));
}
exports.default = TrashIcon;
//# sourceMappingURL=index.js.map